(() => {
  const root = document.documentElement;
  const pendingClass = 'oh-privacy-pending';
  let listening = false;
  let focusObserver = null;
  let watchedBanner = null;
  let handoffScheduled = false;

  const privacy = () => window.Shopify && window.Shopify.customerPrivacy;

  function hasDecision() {
    const api = privacy();
    if (!api || typeof api.currentVisitorConsent !== 'function') return false;
    try {
      const consent = api.currentVisitorConsent();
      return Boolean(consent && ['marketing', 'analytics', 'preferences', 'sale_of_data']
        .some((key) => consent[key] === 'yes' || consent[key] === 'no'));
    } catch (_) { return false; }
  }

  function sync() {
    const api = privacy();
    if (!api || typeof api.shouldShowBanner !== 'function') return false;
    let pending = false;
    try {
      const consent = typeof api.currentVisitorConsent === 'function' ? api.currentVisitorConsent() : null;
      const undecided = !consent || !['marketing', 'analytics', 'preferences', 'sale_of_data']
        .some((key) => consent[key] === 'yes' || consent[key] === 'no');
      pending = api.shouldShowBanner() && undecided;
    } catch (_) { return false; }
    root.classList.toggle(pendingClass, Boolean(pending));
    return true;
  }

  function visibleBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    return banner && banner.getClientRects().length ? banner : null;
  }

  function focusConsent() {
    const banner = visibleBanner();
    const controls = banner && [...banner.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')];
    const target = controls && (controls.find((element) => element.tagName === 'BUTTON' && element.getClientRects().length && !element.disabled)
      || controls.find((element) => element.getClientRects().length && !element.disabled));
    if (target) target.focus({preventScroll: true});
    return Boolean(target);
  }

  function stopWatching() {
    if (focusObserver) focusObserver.disconnect();
    focusObserver = null;
    watchedBanner = null;
    handoffScheduled = false;
  }

  function handOffToConsent() {
    if (handoffScheduled) return true;
    if (!visibleBanner()) return false;
    const overlay = document.getElementById('ohLcOverlay');
    if (overlay && overlay.classList.contains('oh-lc-open')) {
      const close = document.getElementById('ohLcClose');
      if (close) {
        handoffScheduled = true;
        close.click();
        // The lens dialog restores its opener on a zero-delay timer.
        setTimeout(() => {
          if (visibleBanner()) focusConsent();
          stopWatching();
        }, 50);
        return true;
      }
    }
    if (!focusConsent()) return false;
    stopWatching();
    return true;
  }

  function watchBannerAttributes() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner === watchedBanner) return;
    watchedBanner = banner;
    focusObserver.observe(banner, {attributes: true, attributeFilter: ['class', 'style', 'hidden']});
  }

  function watchLateBanner() {
    if (hasDecision()) return;
    if (handOffToConsent() || focusObserver) return;
    focusObserver = new MutationObserver(() => {
      watchBannerAttributes();
      handOffToConsent();
    });
    // Only node additions/removals across the page; attribute changes are
    // observed on Shopify's banner itself, not on every product element.
    focusObserver.observe(root, {childList: true, subtree: true});
    watchBannerAttributes();
  }

  function bind() {
    if (listening) return;
    listening = true;
    sync();
    document.addEventListener('visitorConsentCollected', () => {
      root.classList.remove(pendingClass);
      stopWatching();
    });
    window.addEventListener('pageshow', sync);
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest && event.target.closest('#ohLcTrigger');
      if (!trigger) return;
      watchLateBanner();
      if (!root.classList.contains(pendingClass)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  bind();
  if (!privacy() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], (error) => {
      if (!error) sync();
    });
  }
})();
